/**
 * Contains all video page components (archive and single).
 */

import domContentLoaded from 'utils/domContentLoaded';
import reactComponentManager from 'utils/reactComponentManager';
import VideoPage from 'components/video-page/index.tsx';
import { checkForAnalytics } from 'components/nbc-jw-player/utils.ts';
import NBCTruncate from 'components/nbc-truncate';

import 'scss/videos/index.scss';

checkForAnalytics();

domContentLoaded(() => {
  document.addEventListener('sObjectLoaded', () => {
    reactComponentManager({
      VideoPage,
      NBCTruncate,
    });
  });
});

if (module.hot) {
  module.hot.accept();

  reactComponentManager({
    VideoPage,
    NBCTruncate,
  });
}
